import { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Phone, MapPin, Sparkles, Megaphone } from "lucide-react";

const CATS = ["सभी", "सामान्य", "रोज़गार", "किराया / प्रॉपर्टी", "व्हीकल", "इलेक्ट्रॉनिक्स", "शिक्षा", "सेवाएँ", "अन्य"];

export default function ClassifiedsPublicPage() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("सभी");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const p = cat === "सभी" ? {} : { category: cat };
    api.get("/classifieds", { params: p }).then((r) => setItems(r.data))
      .catch(() => setItems([])).finally(() => setLoading(false));
  }, [cat]);

  return (
    <>
      <PublicHeader />
      <section className="bg-gradient-to-br from-[#0F172A] to-[#1E3A8A] text-white">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="flex items-center gap-3 mb-2"><Megaphone className="w-5 h-5 text-amber-300"/>
            <span className="uppercase tracking-[0.28em] text-[11px] text-amber-300 font-black">Classifieds · वर्गीकृत विज्ञापन</span></div>
          <h1 className="font-devnagri-heading text-4xl md:text-5xl font-black">बाज़ार <span className="text-amber-300">आपके शहर का</span></h1>
          <p className="text-slate-300 mt-3">नौकरी, किराया, व्हीकल, इलेक्ट्रॉनिक्स — सब यहाँ मिलेगा।</p>
          <a href="/post-ad" className="inline-block mt-5 bg-amber-500 hover:bg-amber-600 text-[#0F172A] font-bold px-5 py-2.5 rounded-md" data-testid="post-ad-cta">+ विज्ञापन दें</a>
        </div>
      </section>
      <main className="max-w-6xl mx-auto px-4 py-10" data-testid="classifieds-page">
        <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap ${cat === c ? "bg-[#0F172A] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}
              data-testid={`cat-${c}`}>{c}</button>
          ))}
        </div>
        {loading ? <div className="text-slate-500">लोड हो रहा है…</div> :
          items.length === 0 ? <div className="text-slate-500 italic py-12 text-center">इस श्रेणी में कोई विज्ञापन नहीं</div> :
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((c) => (
              <div key={c.id} className={`bg-white rounded-lg overflow-hidden border-2 ${
                c.package_id === "premium" ? "border-amber-400 shadow-lg" : c.package_id === "featured" ? "border-orange-300" : "border-slate-200"
              }`} data-testid={`ad-${c.id}`}>
                {c.image_url && <div className="aspect-video bg-slate-100"><img src={c.image_url} alt="" className="w-full h-full object-cover"/></div>}
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] uppercase tracking-widest text-[#EA580C] font-bold">{c.category}</span>
                    {c.package_id === "premium" && <span className="flex items-center gap-1 bg-amber-100 text-amber-800 text-[10px] font-bold px-2 py-0.5 rounded"><Sparkles className="w-3 h-3"/>Premium</span>}
                  </div>
                  <h3 className="font-bold text-[#0F172A] leading-tight mb-1">{c.title}</h3>
                  <p className="text-sm text-slate-600 line-clamp-3">{c.description}</p>
                  <div className="mt-3 pt-3 border-t border-slate-100 space-y-1">
                    <div className="flex items-center gap-2 text-sm text-slate-700"><Phone className="w-3.5 h-3.5"/><a href={`tel:${c.phone}`} className="hover:text-[#DC2626]">{c.phone}</a></div>
                    {c.area && <div className="flex items-center gap-2 text-xs text-slate-500"><MapPin className="w-3 h-3"/>{c.area}</div>}
                    <div className="text-[10px] text-slate-400">— {c.contact_name}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        }
      </main>
      <PublicFooter />
    </>
  );
}
